var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "btn btn-default",
      class: [
        _vm.favStatus ? "fav-active" : "fav-inactive",
        { "float-right": !_vm.$mq.phone }
      ],
      on: {
        click: function($event) {
          return _vm.saveFavProfessional(_vm.professional.id)
        }
      }
    },
    [_c("i", { staticClass: "fa-heart", class: _vm.favStatus ? "fas" : "far" })]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d4989450", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d4989450","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/booking/components/ButtonFavoriteProfessional.vue
// module id = 1879
// module chunks = 0